<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-user-follow-line me-1 text-primary"></i>Employee Course Allocation
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertEmployeeCourseAllocation()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): course.employeeCourseAllocation.edit' : ''">
                                    <i class="bx bx-plus"></i> Add Course Allocation
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Employee Name</th>
                                    <th scope="col" width="300">Course Test Name</th>
                                    <th scope="col" width="300">From Date</th>
                                    <th scope="col" width="300">To Date</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let courseAllocation of courseAllocations; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{courseAllocation.employeeName}}
                                    </td>
                                    <td>{{courseAllocation.courseTestName}}</td>
                                    <td>{{courseAllocation.startDate| date:'MMM dd, yyyy'}}</td>
                                    <td>{{courseAllocation.endDate| date:'MMM dd, yyyy'}}</td>
                                    <td class="actions">
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':courseAllocation?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): course.employeeCourseAllocation.edit' : 'Update CourseAllocation'"
                                            (click)="upsertEmployeeCourseAllocation(courseAllocation)"></i>
                                        <i *ngIf="!courseAllocation?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): course.employeeCourseAllocation.delete' : 'Delete CourseAllocation'"
                                            (click)="deleteEmployeeCourseAllocation(courseAllocation,i)"></i>
                                        <div *ngIf="courseAllocation?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="8">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="courseAllocation && courseAllocation.length < 1; else noSearchResults">
                                            <td colspan="8">No course were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="8"
                                                *ngIf="searchKeyword && (courseAllocation | search : 'courseTestName' : searchKeyword).length == 0">
                                                No course were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>